import { getRuntimeIslandKey } from '../lib/siteContext';

const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL || 'https://us-central1-alakaialohaadventures-782c9.cloudfunctions.net';

function buildQuery(params) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (typeof value === 'string' && value.trim().length > 0) {
      usp.append(key, value);
    }
  });
  return usp.toString();
}

export async function requestItineraryPdf(itineraryId, versionId) {
  if (!itineraryId || !versionId) {
    return { success: false, error: 'Missing itinerary reference.' };
  }

  const query = buildQuery({ itineraryId, versionId, islandKey: getRuntimeIslandKey() });
  const endpoint = `${FUNCTIONS_BASE_URL}/itineraryPdf?${query}`;

  try {
    const response = await fetch(endpoint, { method: 'GET' });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const error = data?.error || 'Unable to generate PDF right now.';
      return { success: false, error };
    }

    if (!data?.url) {
      return { success: false, error: 'PDF download link was missing.' };
    }

    try {
      window.location.assign(data.url);
    } catch (downloadError) {
      console.error('[pdfService] failed to trigger download', downloadError);
      return { success: false, error: 'We generated your PDF but could not start the download. Please retry.' };
    }

    return { success: true };
  } catch (error) {
    console.error('[pdfService] request failed', error);
    return { success: false, error: 'Unable to reach the PDF service. Please try again shortly.' };
  }
}
